import { IController } from 'angular';
import { ManageUsersCreateOrEditUserModal } from './../manage-users-modals/create-or-edit-user/manage-users-create-or-edit-user-modal.service';
import { IManageUsersSchool } from './../manage-users.controller';

export class ManageUsersFabCtrl implements IController {
  static $inject: string[] = ['ManageUsersCreateOrEditUserModal', 'Rollbar'];

  // bindings
  addNewSchoolUser;
  school: IManageUsersSchool;

  constructor(private manageUsersCreateOrEditUserModal: ManageUsersCreateOrEditUserModal, private Rollbar) {
    //
  }

  $onInit() {
    //
  }

  $onChanges(changesObj) {
    //
  }

  showCreateNewUserModal() {
    this.manageUsersCreateOrEditUserModal
      .show(this.school)
      .then(results => {
        const createdUser = results && results.createdUser;

        if (createdUser) {
          this.addNewSchoolUser({
            schoolUser: createdUser,
          });
        }
      })
      .catch(err => {
        this.Rollbar.error(`Unable to add new school user: `, err);
      });
  }
}
